var _g, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteusWhite01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 150",
    enableBackground: "new 0 0 1000 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.4,16.8H19.6c-5,0-8.2,3.1-8.2,8.2v102.2c0,5,3.1,8.2,8.2,8.2H21c5,0,8.2-3.1,8.2-8.2V92.9h22.2 c23.3,0,39-15.3,39-38C90.3,32.1,74.7,16.8,51.4,16.8z M51.4,75.6H29.2V34.1h22.2c12.6,0,20.8,8.2,20.8,20.8 C72.1,67.5,64,75.6,51.4,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M211.8,90.4c14.7-5.4,23.6-18.6,23.6-35.5c0-22.8-15.7-38-39-38h-31.8c-5,0-8.2,3.1-8.2,8.2v102.2 c0,5,3.1,8.2,8.2,8.2h1.4c5,0,8.2-3.1,8.2-8.2V92.9h16.3l30.3,38.4c2.4,2.8,5,4.1,8.5,4.1h3.6c3.3,0,5.8-1.3,6.9-3.6 c1.1-2.3,0.5-5.1-1.5-7.6L211.8,90.4z M217.2,54.9c0,12.6-8.2,20.8-20.8,20.8h-22.2V34.1h22.2C209,34.1,217.2,42.2,217.2,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M546.6,16.8h-77.4c-5,0-8.2,3.1-8.2,8.2v0.9c0,5,3.1,8.2,8.2,8.2h29.9v93.1c0,5,3.1,8.2,8.2,8.2h1.4 c5,0,8.2-3.1,8.2-8.2V34.1h29.7c5,0,8.2-3.1,8.2-8.2V25C554.7,19.9,551.6,16.8,546.6,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M680.9,16.8h-55c-5,0-8.2,3.1-8.2,8.2v102.2c0,5,3.1,8.2,8.2,8.2h55c5,0,8.2-3.1,8.2-8.2v-0.9 c0-5-3.1-8.2-8.2-8.2h-45.5V76.5h42.5c5,0,8.2-3.1,8.2-8.2v-0.9c0-5-3.1-8.2-8.2-8.2h-42.5V34.1h45.5c5,0,8.2-3.1,8.2-8.2V25 C689.1,19.9,685.9,16.8,680.9,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M842.6,16.8h-1.4c-5,0-8.2,3.1-8.2,8.2v66.7c0,18.1-10.3,28.5-28.3,28.5c-18.2,0-28.6-10.4-28.6-28.5V25 c0-5-3.1-8.2-8.2-8.2h-1.4c-5,0-8.2,3.1-8.2,8.2v66.7c0,28.9,17.3,46.2,46.4,46.2c28.8,0,46.1-17.3,46.1-46.2V25 C850.8,19.9,847.6,16.8,842.6,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M954.3,63.7c-13.7-4.3-18.1-8-18.1-15.4c0-7.5,6-15.4,17.2-15.4c5.6,0,11.1,3.1,13.9,7.8 c1.4,2.5,3.7,5.4,8.7,5.4h2.5c2.9,0,5.3-1.1,6.6-3c1.3-1.9,1.5-4.3,0.6-6.9c-5-12.8-17.7-21-32.3-21C932.9,15.1,918,29,918,48.3 c0,19.6,13.8,27.9,34.4,34.3c18.7,5.8,22.3,11.2,22.3,18.6c0,12.4-10.8,18-21.4,18c-9,0-16.9-4.9-20-12.3 c-1.6-4.2-4.4-6.2-8.6-6.2h-1.9c-2.9,0-5.2,1-6.6,2.8c-0.9,1.2-1.9,3.4-1,6.7c4.9,16,20.2,26.8,38.1,26.8c23,0,39.6-15,39.6-35.7 C993,77.8,973,69.6,954.3,63.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.2083,
    y1: 9.8836,
    x2: 388.2083,
    y2: 109.2865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69C5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06145377,
    style: {
      stopColor: "#63BBAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#4094B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6631,
    style: {
      stopColor: "#287DBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7957,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M361.9,10c0.1-0.7,12.4,1,13.8,1.4c11.2,2.7,32.2,13.9,22,28.4c-3.3,4.8-12.8,11.1-12.4,17.6 c0.6,8.9,19.9-0.7,24.6-0.6c11.4,0.1,12.2,13,11.7,21.4c-0.6,10.9-4.8,20.6-9.7,30.1c-2.5,4.8-1.4-8.8-6.4-7.8 c-11.5,2.2-22.5,2.8-34.1,1.5c-0.4,0-8-0.6-8.1-0.8c0,0-8.9-52.3-8.9-52.3L361.9,10z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.9814,
    y1: 8.9351,
    x2: 361.9814,
    y2: 131.495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69C5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06145377,
    style: {
      stopColor: "#63BBAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#4094B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6631,
    style: {
      stopColor: "#287DBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7957,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M418.9,87.9c-0.7,5.4-2.6,11-4.5,15.3c-0.8,1.7-1.5,3.4-2.4,5c0,0,0,0,0,0 c-0.4,0.7-0.7,1.5-1.1,2.2c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.4-0.6,0.9-0.9,1.3c0,0,0,0,0,0c-5.5,8-12.7,14.7-21.1,19.5 c-8.8,0-14.4-10-14.4-10l-2.5-1.5l-37.8-22.5l-17.3-33.4c0,0-12-27-12-27c-0.1-0.7,6.9-9.2,10.1-12.7c0.4-0.5,0.8-0.9,1-1.2 c0.2-0.2,0.4-0.4,0.4-0.4c0.6-0.4,1.3-0.8,1.9-1.2c3.2-2.1,6.6-4,10.1-5.7c0.2-0.1,0.5-0.2,0.7-0.3c11.1-5.3,23.5-7.8,35.6-6 c8.2,1.2,22,6.2,23.5,15.6c1.4,8.4-6.2,15.8-10.4,22.1c-2.2,3.2-5.6,7.8-6.4,11.7c-1.6,8.3,2.4,16.7,11.7,16.1 c7.7-0.4,14.3-5.1,22.2-5C417.6,70.1,420.1,78.7,418.9,87.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.4969,
    y1: 9.4893,
    x2: 355.4969,
    y2: 124.13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69C5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4974,
    style: {
      stopColor: "#479CB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M293.6,74.6c0,0,15-30.4,15-30.4c0.4-1.3,4.1-7.7,5-8.7c3.3-3.4,0.8-11.5,4.7-14.1 c8.2-5.6,18.3-9.8,28.1-11.2c6.9-1,14.5-1.3,20.3,3c4.2,3.1,7,7.3,7.3,12.6c0.3,5.7-2.6,9.2-5.1,14c-1.5,3-3,6-4.3,9.1 c-2.5,5.9-4.7,12-5.3,18.4c-1,11.8,5.4,20.5,17.7,20.3c10.9-0.2,30.5-13.4,38.7-1.4c2.5,3.7,1.9,8.5,0.5,12.5 c-1.7,5.2-4.2,13.2-10.3,14.6c-5.5,1.3-10.9,2.9-16.5,4c-13.1,2.5-26.4,4-39.6,5.5c-1.1,0.1-8.3,1.9-9.2,1.1 C340.8,123.9,293.6,74.6,293.6,74.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.4738,
    y1: 18.1487,
    x2: 351.4738,
    y2: 140.2943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69C5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4974,
    style: {
      stopColor: "#479CB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C75BC"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M411.5,108.1c-0.6,1.6-1.3,3.1-2.1,4.3c-4.8,7.6-12.9,14.6-20.7,19.1c-9.7,5.6-20.9,8.8-32.8,8.8 c-36.2,0-65.6-29.4-65.6-65.6c0-15.2,5.2-29.1,13.8-40.3c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.3,0.6-0.7,0.8-1c0.2-0.2,0.3-0.4,0.5-0.6 c0.2-0.2,0.4-0.5,0.6-0.7c0.6-0.6,1.1-1.3,1.7-1.9c0,0,0,0,0,0c0.8-0.8,1.7-1.6,2.6-2.4c0,0,0.1-0.1,0.1-0.1c1.3-1.1,2.6-2.1,4-3 c9.2-6,28.3-10.3,36.8,0.2c6.7,8.3,3.3,19.2,0.6,28.4c-3.2,10.9-6.3,22.3-1.1,33.1c5.5,11.4,18,16.6,30.2,15 c3.6-0.5,7-1.4,10.4-2.6c4.8-1.7,8.7-5,14.1-4.1C413.4,95.7,413.5,102.4,411.5,108.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4062AD",
    d: "M375.5,110.3c-0.3,0.6-0.6,1.1-1.1,1.7C374.8,111.4,375.1,110.8,375.5,110.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteusWhite01);
export default __webpack_public_path__ + "static/media/Proteus_White-01.521dba90bc379b2d00067d5564260204.svg";
export { ForwardRef as ReactComponent };